import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import cx from 'clsx';
import styles from './index.module.scss';
import { CommonModal } from '@/components/Modal/CommonModal';
import { useCurrentAddressInfo, useSwitch } from '@/hooks';
import { useSuicideText } from '@/views/Settings/components/SuicideModal/hooks';
import { Button } from '@/components';

export const SuicideTag = ({
  userAddress,
  className,
  enableViewText,
  onClick,
}: {
  userAddress?: string;
  className?: string;
  enableViewText?: boolean;
  onClick?: () => void;
}) => {
  const { t } = useTranslation();

  const { on, turnOff, turnOn } = useSwitch();
  const { data: text } = useSuicideText({ enabled: on });
  const { userInfo, address } = useCurrentAddressInfo();
  const handleClick = useCallback(() => {
    onClick?.();
    if (address !== userAddress || !enableViewText) {
      return;
    }
    turnOn();
  }, [address, enableViewText, onClick, turnOn, userAddress]);
  return (
    <>
      <div
        className={cx(styles.suicideTag, address !== userAddress && styles.pointerNone, className)}
        onClick={handleClick}>
        {t('SuicideTag.152shzq')}
      </div>
      <CommonModal on={on} turnOff={turnOff} headerTitle={t('SuicideTag.suicideMsg')}>
        <div className={styles.signatureText}>
          {'{\n'}&nbsp;&nbsp;&nbsp;&nbsp;{`\b"${text || ''}"`}
          {'\n}'}
        </div>
        <div className={styles.signature}>
          {t('SuicideTag.f4o78i')}
          {'\n'}
          {userInfo?.suicide_signature}
        </div>
        <div className={styles.btnContainer}>
          <Button className={styles.btn} onClick={turnOff} type="primary">
            {t('SuicideTag.2qk')}
          </Button>
        </div>
      </CommonModal>
    </>
  );
};
